import { Component, OnInit, Input, AfterViewInit, ChangeDetectionStrategy } from '@angular/core';
import { ThemePalette } from '@angular/material/core';
import { UntypedFormGroup, Validators } from '@angular/forms';
import { typeDHLFormControls } from '../../models/dhl-form-shared-types';

@Component({
    selector: 'app-form-field-slide-toggle',
    templateUrl: './form-field-slide-toggle.component.html',
    styleUrls: ['./form-field-slide-toggle.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FormFieldSlideToggleComponent implements OnInit, AfterViewInit {

  @Input() configData: typeDHLFormControls;
  @Input() frmGroup: UntypedFormGroup;
  
  constructor() { }

  ngOnInit() {
    let affectedCol =  this.configData['affectedColumns'];
    if(this.configData['editable'] === false){
      this.frmGroup.get(this.configData.name).disable();
    } 
  }

  ngAfterViewInit(){
    this.frmGroup.get(this.configData.name).setValue(false);
    if(this.configData.defaultValue && this.configData.defaultValue.value == "true"){
      this.frmGroup.get(this.configData.name).setValue(true);
    }
  }

  color: ThemePalette = 'accent';
  checked = false;
  disabled = false;
  
  manageToggleData(value){
    if(!this.configData['affectedColumns'] || !this.configData['affectedColumns'].length){
      return
    }
    if(value.checked === true){
      this.configData['affectedColumns'].forEach(element => {
        let multipleValue;
        if(element.multipleValue){
          multipleValue = element.multipleValue;
        } else {
          multipleValue = element.value;
        }
        multipleValue.forEach(field => {
          this.frmGroup.get(field)['hidden'] = false;
          let val = this.frmGroup.get(field).value;
          this.frmGroup.get(field).reset();
          this.frmGroup.get(field).setValue(val)
          this.frmGroup.get(field).setValidators([Validators.required]);
          this.frmGroup.get(field).updateValueAndValidity();
        })
      }, this);
    } else if ((value.checked === false || value === '') && this.configData['affectedColumns'] != undefined) {
      this.configData['affectedColumns'].forEach(element => {
        let elementValue;
        if(element.multipleValue){
          elementValue = element.multipleValue;
        } else {
          elementValue = element.value;
        }
        elementValue.forEach(field => {
          this.frmGroup.get(field)['hidden'] = true;
          this.frmGroup.get(field).setValidators(null);
          this.frmGroup.get(field).updateValueAndValidity();
        })
      });
    }
  }
}
